module.exports = __webpack_public_path__ + "img/block-768.91505473.jpg";